var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "t-wrapper" }, [
    _c("div", { staticClass: "t-wrapper__body" }, [
      _c("div", { staticClass: "t-wrapper__content" }, [
        _c(
          "div",
          { staticClass: "t-wrapper__loader" },
          [
            _c("Loader", {
              staticClass: "t-mar--t-xxl",
              attrs: { size: "xl" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("h4", { staticClass: "t-tf--heading t-mar--t-md t-ta--center" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("generic.text.redirect_back_to_trainn")) +
              "\n      "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }